@if (campaign) {
  <app-account-actions [pageTitle]="title" [imageUuid]="imageUuid">
    <div content>
      <div [innerHTML]="description"></div>
      <div class="mt-1">
        <ut-button
          variant="primary"
          (clicked)="nav.signup()"
        >
          {{ 'button.sign up' | translate }}
        </ut-button>
      </div>
    </div>
  </app-account-actions>
}
